package org.mkui.graphics

import com.macrofocus.common.geom.PreferredSize
import org.mkui.color.MkColor
import org.mkui.font.CPFontMetrics
import org.mkui.font.MkFont
import org.mkui.geom.Point2D
import org.mkui.geom.Rectangle2D
import org.mkui.geom.Shape
import org.mkui.labeling.EnhancedLabel

interface IGraphics {
    enum class TextBaseline {
        Top, Bottom, Middle, Alphabetic, Ideographic, Hanging
    }

    fun paintLabel(l: EnhancedLabel, x: Int, y: Int, w: Int, h: Int)
    fun sizeLabel(l: EnhancedLabel, w: Int, h: Int): PreferredSize

    fun isThreadSafe(): Boolean

    fun beginPick()

    fun getLineWidth(): Double

    fun setLineWidth(lineWidth: Double)

    fun setLineDash(dashPatern: FloatArray?)

    fun setGlobalAlpha(alpha: Double)

    fun getColor(): MkColor

    fun setColor(color: MkColor)

    fun drawShape(shape: Shape)

    fun drawPoint(point: Point2D?)

    fun drawLine(x1: Int, y1: Int, x2: Int, y2: Int)

    fun drawLine(x1: Double, y1: Double, x2: Double, y2: Double)

    fun fillCircle(rectangle: Rectangle2D)

    fun fillRectangle2D(rectangle: Rectangle2D)

    fun fillRectangle(x1: Int, y1: Int, x2: Int, y2: Int)

    fun drawRectange(x1: Int, y1: Int, x2: Int, y2: Int)

    fun strokeRoundRect(x: Double, y: Double, width: Double, height: Double, arcWidth: Double, arcHeight: Double)

    fun fillRoundRect(x: Double, y: Double, width: Double, height: Double, arcWidth: Double, arcHeight: Double)

    fun fillShape(shape: Shape)

    fun <T> pickDraw(geometry: Shape, point: Point2D?, value: T, callback: ICallback<T>?)

//    fun <T> pickFill(geometry: Shape?, point: Point2D?, value: T, callback: ICallback<T>?)

    fun endPick()

    fun setTextBaseline(baseline: TextBaseline?)

    fun setFont(font: MkFont?)

    fun getStringBounds(text: String): Rectangle2D

    fun getStringWidth(text: String): Float

    fun getStringHeight(text: String): Float

    fun getAscent(): Double

    fun getDescent(): Double

    fun getFontMetrics(): CPFontMetrics?

    fun drawString(text: String, x: Float, y: Float)

    fun drawCircularString(
        text: String,
        centerX: Float,
        centerY: Float,
        diameter: Float,
        startAngle: Float,
        extent: Float
    )

    fun translate(x: Int, y: Int)

    fun rotate(theta: Double)

    fun beginPath()

    fun moveTo(x: Double, y: Double)

    fun lineTo(x: Double, y: Double)

    fun closePath()

    fun stroke()

    fun fill()
}